module.exports = __webpack_public_path__ + "static/media/AkkuratLight.06d7de3d.woff2";